import { Grid, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import CardCountUsers from "../components/CardCountUsers";
import Loading from "../components/Loading";
import TableDocuments from "../components/TableDocuments";
import TableUsers from "../components/TableUsers";
import api from "../services/api";
import auth from "../services/auth";

export default function Dashboard() {
  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState([]);

  if (error) {
  }

  const onRequest = async () => {
    await api
      .get("users", { headers: auth.token() })
      .then((response) => {
        if (!response.data.data) {
          setUsers([]);
        } else {
          setUsers(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    await api
      .get("documents", { headers: auth.token() })
      .then((response) => {
        if (response.status === 200) {
          if (!response.data.data) {
            setDocuments([]);
          } else {
            setDocuments(response.data.data);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    onRequest();
    return () => {
      setError(null);
      setUsers([]);
      setLoading(false);
    };
  }, []);

  return loading ? (
    <Loading />
  ) : (
    <Grid container spacing={3}>
      {/* Chart */}
      <Grid item xs={12} md={8} lg={9}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            height: 240,
          }}
        >
          <TableUsers users={users} />
        </Paper>
      </Grid>
      {/* Recent CountUsers */}
      <Grid item xs={12} md={4} lg={3}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            height: 240,
          }}
        >
          <CardCountUsers count={users ? users.length : 0} />
        </Paper>
      </Grid>
      {/* Recent Orders */}
      <Grid item xs={12}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            height: 240,
          }}
        >
          <TableDocuments documents={documents} />
        </Paper>
      </Grid>
    </Grid>
  );
}
